import React, {useContext} from 'react';
import {  Theme } from '@mui/material';
import {  alpha } from '@mui/material/styles';
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import {makeStyles } from "@mui/styles";
import {TextDisplay} from "./data-display/TextDisplay";
import {LanguageContext} from "../../config/ContextConfig";
import {LanguageProp} from "../../config/LanguageConfig";


interface ImportantTextBoxOwnProps {
    text: string
}

interface ImportantTextBoxProps extends Partial< LanguageProp > {
    text: string
}

const useStyle = makeStyles(( theme: Theme ) => ({
    importantBox: {
        textAlign: 'left',
        backgroundColor: alpha( theme.palette.secondary.light, 0.3),
        marginLeft: 5+'px',
        marginRight: '5px',
        padding: '5px'
    }
}));


const ImportantTextBox = (props: ImportantTextBoxProps) => {
    const language = useContext( LanguageContext );
    const classes = useStyle();

    return (
        <div className={classes.importantBox}>
            <TextDisplay >
                <NotificationImportantIcon fontSize="small" />
                { language.common.importantTitle}
            </TextDisplay>
             <TextDisplay>
                {props.text}     
            </TextDisplay>
        </div>
    );
};

export default ImportantTextBox;